/**
 * Browser API origin.
 * Leave empty for same-origin `/api/*` (Vite proxy in dev/preview, nginx in production).
 * Set VITE_API_BASE_URL only when the SPA is hosted on a different origin than the API.
 */
export function apiUrl(path: string): string {
  const base = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') || ''
  if (!path.startsWith('/')) return `${base}/${path}`
  return `${base}${path}`
}
